import QuantityProduct from './QuantityProduct'

class PremiumPhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 10
}

export default PremiumPhotoProduct
